import { useState } from 'react';
import { useIsAccountDormant } from 'lib/hooks';

const useAccountDormantModal = () => {
    const isDormant = useIsAccountDormant();
    const [showDormantModal, setShowDormantModal] = useState(isDormant);

    function handleClose() {
        setShowDormantModal(false);
    }

    return [showDormantModal, handleClose];
};

export default useAccountDormantModal;
